import { html } from 'gisw/Helpers/html';

import './banner-message.less';

/**
 * @param {string} message
 * @param {() => void} [onClose]
 */
function bannerMessage (message, onClose = null) {
  const domNode = html`<div class="banner-message">
    <span>${message}</span>
  </div>`.item(0);
  document.body.prepend(domNode);

  /** @type {HTMLButtonElement} */
  // @ts-ignore
  const dismissButton = html`<button class="btn btn-link close" type="button">
    <span aria-hidden="true">&times;</span>
    <span class="sr-only">Dismiss</span>
  </button>`.item(0);
  dismissButton.addEventListener('click', () => {
    if (onClose) {
      onClose();
    }

    domNode.remove();
  });
  domNode.appendChild(dismissButton);
}

export default bannerMessage;
